<template>
  <div>
    <!-- #region NAVBAR   -->
    <nav >
      <ul class="nav-wrapper">
        <li class="icon">
          <RouterLink to="/">
            <span class="tooltip">Home</span>
            <span><i class="fa-solid fa-house text-white ml-5"> </i></span
          ></RouterLink>
        </li>

        <li>
          <a href="#">
            <div class="ml-5 text-base lg:text-2xl text-white cursor-default">
              {{ `Aircraft` }}
            </div>
          </a>
        </li>

        <li @click="getData" class="icon">
          <a href="#">
            <span class="tooltip">Refresh</span>
            <span><i class="ml-5 fa-solid fa-rotate"></i></span>
          </a>
        </li>

        <li>
          <RouterLink to="/">
            <div class="mr-5 text-sm text-white pointer-default">
              {{ `Aircraft: ${aircraft.length}` }}
            </div>
          </RouterLink>
        </li>
      </ul>
    </nav>

    <r-snackbar
      v-if="snackbarVisible"
      :backgroundColor="snackbarColor"
      :message="snackbarText"
      :timeout="3000"
      @close="snackbarVisible = false"
    >
    </r-snackbar>

    <!-- LOADING -->

    <r-spinner v-if="loading"> </r-spinner>

    <!-- Data Table -->
    <div class="relative overflow-x-auto">
      <table
        v-if="aircraft.length"
        class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
      >
        <thead
          class="text-xs text-gray-200 uppercase bg-gray-500 dark:bg-gray-700 dark:text-gray-400"
        >
          <tr>
            <th scope="col" class="px-6 py-2 cursor-pointer">#</th>
            <th
              scope="col"
              class="px-6 py-2 cursor-pointer"
              @click="sortArrayByKey('registration')"
            >
              REGISTRATION
            </th>
            <th
              scope="col"
              class="px-6 py-2 cursor-pointer"
              @click="sortArrayByKey('type')"
            >
              TYPE
            </th>
            <th
              scope="col"
              class="px-6 py-2 cursor-pointer"
              @click="sortArrayByKey('cargoOnly')"
            >
              CONFIGURATION
            </th>

            <th
              scope="col"
              class="px-6 py-2 cursor-pointer"
              @click="sortArrayByKey('upperFloorType')"
            >
              Main Deck Floor
            </th>

            <th
              scope="col"
              class="px-6 py-2 cursor-pointer"
              @click="sortArrayByKey('lowerFloorType')"
            >
              Lower Deck Floor
            </th>

            <th scope="col" class="px-6 py-2">SWA Categories</th>
            <th scope="col" class="px-6 py-2">Buffer Weights</th>

            <th
              scope="col"
              class="px-6 py-2 cursor-pointer"
              @click="sortArrayByKey('status')"
            >
              Status
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(ac, index) in aircraft"
            :key="index"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 cursor-pointer"
            v-on:click="
              user.securityGroup.keys.includes(802)
                ? handleShowAircraftInformation(ac)
                : null
            "
          >
            <td
              scope="row"
              class="w-24 px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {{ index + 1 }}
            </td>
            <td
              scope="row"
              class="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {{ ac.registration }}
            </td>

            <td class="px-6 py-2">{{ ac.typeDescription }}</td>

            <td class="px-6 py-2">
              {{ ac.cargoOnly ? "Cargo" : "Passengers" }}
            </td>

            <td class="px-6 py-2">{{ ac.upperFloorType }}</td>
            <td class="px-6 py-2">{{ ac.lowerFloorType }}</td>
            <td class="px-6 py-2">
              {{
                !ac.cargoOnly && ac.swaCategories.length
                  ? ac.swaCategories
                      .map((item) => `${item.name}: ${item.value}`)
                      .join(", ")
                  : "N/A"
              }}
            </td>
            <td class="px-6 py-2">
              {{
                !ac.cargoOnly && ac.bufferWeights.length
                  ? ac.bufferWeights
                      .map((item) => `${item.name}: ${item.value}`)
                      .join(", ")
                  : "N/A"
              }}
            </td>
            <td class="px-6 py-2">{{ ac.status }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else class="p-5 text-2xl text-green-600">
        No aircraft found with the selected filters
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import authentication from "../services/authentication";
import { mixin } from "../mixins/mixin";
import RSnackbar from "../components/RSnackbar.vue";
import RSpinner from "../components/RSpinner.vue";
import RModal from "../components/RModal.vue";
import { Switch } from "@headlessui/vue";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/20/solid";

export default {
  name: "aircraft",
  mixins: [mixin],
  components: {
    RSnackbar,
    RSpinner,
    RModal,
    Switch,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ChevronUpDownIcon,
  },

  data() {
    return {
      loading: false,

      inactivityTimer: null,

      aircraft: [],
      error: null,
      typeOptions: [
        "737",
        "738",
        "744",
        "747",
        "748",
        "763",
        "74Y",
        "76F",
        "77F",
        "LCF",
        "PAX",
      ],

      //-------------------------Snackbar
      snackbarVisible: false,
      snackbarText: "",
      snackbarColor: "white",
      snackbarTimeout: 5000,
    };
  },

  created() {
    (async () => {
      this.getData();
    })();
  },

  mounted() {
    this.startInactivityTimer();
    document.addEventListener("click", this.resetInactivityTimer);
  },
  unmounted() {
    this.clearInactivityTimer();
    document.removeEventListener("click", this.resetInactivityTimer);
  },

  computed: {
    auth() {
      return this.$store.state.auth;
    },

    user() {
      return this.$store.state.user;
    },
    sortedBy() {
      return this.$store.getters.aircraftSortedBy;
    },
  },

  methods: {
    startInactivityTimer() {
      this.clearInactivityTimer();
      this.inactivityTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.timeoutDuration);
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
    },

    resetInactivityTimer() {
      this.startInactivityTimer();
    },

    async handleAutoLogout() {
      try {
        //---------------------------------------Refresh Token
        this.loading = true;
        const accessToken = await authentication.getAccessToken();
        if (!accessToken) {
          this.loading = false;
          return;
        }

        await api.get("/auth/logout", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        this.loading = false;

        this.$store.commit("updateAuth", null);
        this.$store.commit("updateUser", null);
        clearTimeout(this.inactivityTimer);
        this.$router.push({ name: "home" });
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "red";
        this.snackbarVisible = true;
        this.snackbarText = `Error during auto-logout: ${error}`;

        setTimeout(() => {
          this.$store.commit("updateAuth", null);
          this.$store.commit("updateUser", null);
          clearTimeout(this.inactivityTimer);
        }, 3000);
      }
    },

    isSortedAsc(arr, key) {
      for (let i = 0; i < arr.length - 1; i++) {
        if (arr[i][key] > arr[i + 1][key]) {
          return false;
        }
      }
      return true;
    },

    sortArrayByKey(key) {
      const sortedAsc = this.isSortedAsc(this.aircraft, key);

      if (sortedAsc) {
        this.aircraft.sort((a, b) => (a[key] < b[key] ? 1 : -1));
      } else {
        this.aircraft.sort((a, b) => (a[key] > b[key] ? 1 : -1));
      }

      this.$store.commit("updateAircraftSortedBy", key);
    },

    async getData() {
      //---------------------------------------Refresh Token
      this.loading = true;
      const accessToken = await authentication.getAccessToken();
      if (!accessToken) {
        this.loading = false;
        this.$router.push({ name: "home" });
        return;
      }

      try {
        const res = await api.get(`/aircrafts`, {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        });

        this.loading = false;

        this.aircraft = res.data.aircraft;

        this.sortArrayByKey(this.sortedBy);

        this.$store.commit("updateAircraft", res.data.aircraft);

        let aircraftFilter = {
          active: false,
          aircraft: [],
        };

        if (this.user.aircraftFilter.active) {
          const _aircraft = this.aircraft.filter((a) => {
            return this.user.aircraftFilter.registrations.includes(
              a.registration
            );
          });

          aircraftFilter = {
            active: true,
            aircraft: _aircraft,
          };
        }

        this.$store.commit("updateFlightBoardAircraftFilter", aircraftFilter);
      } catch (error) {
        this.loading = false;
        this.snackbarColor = "red";
        this.snackbarText = error;
        this.snackbarVisible = true;
      }
    },

    handleShowAircraftInformation(aircraft) {
      if (!this.user.securityGroup.keys.includes(801)) {
        this.snackbarColor = "red";
        this.snackbarText = "Not authorized.Please contact your administrator.";
        this.snackbarVisible = true;
        return;
      }

      let selectedAircraft = { ...aircraft };

      if (selectedAircraft.cargoOnly) {
        selectedAircraft.deck = "Cargo";
      } else {
        selectedAircraft.deck = "Passengers";
      }

      if (selectedAircraft.cabinConfig) {
        // Cabin Configuration
        let cabin;

        cabin = selectedAircraft.cabinConfig[0];

        if (cabin) {
          selectedAircraft.cabinOne = {
            active: true,
            class: selectedAircraft.cabinConfig[0].class,
            seats: selectedAircraft.cabinConfig[0].seats,
          };
        } else {
          selectedAircraft.cabinOne = {
            active: false,
            class: "A",
            seats: 100,
          };
        }

        cabin = selectedAircraft.cabinConfig[1];

        if (cabin) {
          selectedAircraft.cabinTwo = {
            active: true,
            class: selectedAircraft.cabinConfig[1].class,
            seats: selectedAircraft.cabinConfig[1].seats,
          };
        } else {
          selectedAircraft.cabinTwo = {
            active: false,
            class: "B",
            seats: 100,
          };
        }

        cabin = selectedAircraft.cabinConfig[2];

        if (cabin) {
          selectedAircraft.cabinThree = {
            active: true,
            class: selectedAircraft.cabinConfig[2].class,
            seats: selectedAircraft.cabinConfig[2].seats,
          };
        } else {
          selectedAircraft.cabinThree = {
            active: false,
            class: "C",
            seats: 100,
          };
        }
      } else {
        selectedAircraft.cabinOne = {
          active: false,
          class: "A",
          seats: 100,
        };
        selectedAircraft.cabinTwo = {
          active: false,
          class: "B",
          seats: 100,
        };
        selectedAircraft.cabinThree = {
          active: false,
          class: "C",
          seats: 100,
        };
      }

      if (selectedAircraft.swaCategories) {
        // SWA Categories
        let category;

        category = selectedAircraft.swaCategories[0];

        if (category) {
          selectedAircraft.swaCategoryOne = {
            active: true,
            name: selectedAircraft.swaCategories[0].name,
            value: selectedAircraft.swaCategories[0].value,
          };
        } else {
          selectedAircraft.swaCategoryOne = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[1];

        if (category) {
          selectedAircraft.swaCategoryTwo = {
            active: true,
            name: selectedAircraft.swaCategories[1].name,
            value: selectedAircraft.swaCategories[1].value,
          };
        } else {
          selectedAircraft.swaCategoryTwo = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[2];

        if (category) {
          selectedAircraft.swaCategoryThree = {
            active: true,
            name: selectedAircraft.swaCategories[2].name,
            value: selectedAircraft.swaCategories[2].value,
          };
        } else {
          selectedAircraft.swaCategoryThree = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[3];

        if (category) {
          selectedAircraft.swaCategoryFour = {
            active: true,
            name: selectedAircraft.swaCategories[3].name,
            value: selectedAircraft.swaCategories[3].value,
          };
        } else {
          selectedAircraft.swaCategoryFour = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[4];

        if (category) {
          selectedAircraft.swaCategoryFive = {
            active: true,
            name: selectedAircraft.swaCategories[4].name,
            value: selectedAircraft.swaCategories[4].value,
          };
        } else {
          selectedAircraft.swaCategoryFive = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[5];

        if (category) {
          selectedAircraft.swaCategorySix = {
            active: true,
            name: selectedAircraft.swaCategories[5].name,
            value: selectedAircraft.swaCategories[5].value,
          };
        } else {
          selectedAircraft.swaCategorySix = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[6];

        if (category) {
          selectedAircraft.swaCategorySeven = {
            active: true,
            name: selectedAircraft.swaCategories[6].name,
            value: selectedAircraft.swaCategories[6].value,
          };
        } else {
          selectedAircraft.swaCategorySeven = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[7];

        if (category) {
          selectedAircraft.swaCategoryEight = {
            active: true,
            name: selectedAircraft.swaCategories[7].name,
            value: selectedAircraft.swaCategories[7].value,
          };
        } else {
          selectedAircraft.swaCategoryEight = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[8];

        if (category) {
          selectedAircraft.swaCategoryNine = {
            active: true,
            name: selectedAircraft.swaCategories[8].name,
            value: selectedAircraft.swaCategories[8].value,
          };
        } else {
          selectedAircraft.swaCategoryNine = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[9];

        if (category) {
          selectedAircraft.swaCategoryTen = {
            active: true,
            name: selectedAircraft.swaCategories[9].name,
            value: selectedAircraft.swaCategories[9].value,
          };
        } else {
          selectedAircraft.swaCategoryTen = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[10];

        if (category) {
          selectedAircraft.swaCategoryEleven = {
            active: true,
            name: selectedAircraft.swaCategories[10].name,
            value: selectedAircraft.swaCategories[10].value,
          };
        } else {
          selectedAircraft.swaCategoryEleven = {
            active: false,
            class: "",
            value: 0,
          };
        }

        category = selectedAircraft.swaCategories[11];

        if (category) {
          selectedAircraft.swaCategoryTwelve = {
            active: true,
            name: selectedAircraft.swaCategories[11].name,
            value: selectedAircraft.swaCategories[11].value,
          };
        } else {
          selectedAircraft.swaCategoryTwelve = {
            active: false,
            class: "",
            value: 0,
          };
        }
      } else {
        selectedAircraft.swaCategoryOne = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryTwo = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryThree = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryFour = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryFive = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategorySix = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategorySeven = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryEight = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryNine = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryTen = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryEleven = {
          active: false,
          name: "",
          value: 0,
        };
        selectedAircraft.swaCategoryTwelve = {
          active: false,
          name: "",
          value: 0,
        };
      }

      if (selectedAircraft.bufferWeights.length) {
        // Buffer Weights
        let bufferWeight;

        bufferWeight = selectedAircraft.bufferWeights[0];

        if (bufferWeight) {
          selectedAircraft.bufferWeightOne = {
            active: true,
            name: selectedAircraft.bufferWeights[0].name,
            value: selectedAircraft.bufferWeights[0].value,
          };
        } else {
          selectedAircraft.bufferWeightOne = {
            active: false,
            class: "",
            value: 0,
          };
        }

        bufferWeight = selectedAircraft.bufferWeights[1];

        if (bufferWeight) {
          selectedAircraft.bufferWeightTwo = {
            active: true,
            name: selectedAircraft.bufferWeights[1].name,
            value: selectedAircraft.bufferWeights[1].value,
          };
        } else {
          selectedAircraft.bufferWeightTwo = {
            active: false,
            class: "",
            value: 0,
          };
        }

        bufferWeight = selectedAircraft.bufferWeights[2];
        if (bufferWeight) {
          selectedAircraft.bufferWeightThree = {
            active: true,
            name: selectedAircraft.bufferWeights[2].name,
            value: selectedAircraft.bufferWeights[2].value,
          };
        } else {
          selectedAircraft.bufferWeightThree = {
            active: false,
            class: "",
            value: 0,
          };
        }
        bufferWeight = selectedAircraft.bufferWeights[3];
        if (bufferWeight) {
          selectedAircraft.bufferWeightFour = {
            active: true,
            name: selectedAircraft.bufferWeights[3].name,
            value: selectedAircraft.bufferWeights[3].value,
          };
        } else {
          selectedAircraft.bufferWeightFour = {
            active: false,
            class: "",
            value: 0,
          };
        }
        bufferWeight = selectedAircraft.bufferWeights[4];
        if (bufferWeight) {
          selectedAircraft.bufferWeightFive = {
            active: true,
            name: selectedAircraft.bufferWeights[4].name,
            value: selectedAircraft.bufferWeights[4].value,
          };
        } else {
          selectedAircraft.bufferWeightFive = {
            active: false,
            class: "",
            value: 0,
          };
        }
        bufferWeight = selectedAircraft.bufferWeights[5];
        if (bufferWeight) {
          selectedAircraft.bufferWeightSix = {
            active: true,
            name: selectedAircraft.bufferWeights[5].name,
            value: selectedAircraft.bufferWeights[5].value,
          };
        } else {
          selectedAircraft.bufferWeightSix = {
            active: false,
            class: "",
            value: 0,
          };
        }
      } else {
        selectedAircraft.bufferWeightOne = {
          active: false,
          name: "A",
          value: 0,
        };
        selectedAircraft.bufferWeightTwo = {
          active: false,
          name: "B",
          value: 0,
        };
        selectedAircraft.bufferWeightThree = {
          active: false,
          name: "C",
          value: 0,
        };
        selectedAircraft.bufferWeightFour = {
          active: false,
          name: "D",
          value: 0,
        };
        selectedAircraft.bufferWeightFive = {
          active: false,
          name: "E",
          value: 0,
        };
        selectedAircraft.bufferWeightSix = {
          active: false,
          name: "F",
          value: 0,
        };
      }

      this.$store.commit("updateSelectedAircraft", selectedAircraft);
      this.$router.push({ name: "selectedAircraft" });
    },

    goHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style scoped>
.actions-filter {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  padding: 3px;
}
</style>
